<template lang="pug">
  el-autocomplete(
    :fetch-suggestions="querySearch"
    :trigger-on-focus="false"
    @select="handleSelect"
    v-model="state"
  )
</template>

<script>
import Vue from 'vue'

export default {
  name: 'ExtensionChoseMedium',
  components: {},
  data () {
    return {
      state: ''
    }
  },
  methods: {
    closeChoseMedium () {
      this.choseMediumVisible = false
    },
    openDialog () {
      this.choseMediumVisible = true
    },
    querySearch (queryString, cb) {
      const items = []
      const unique = []
      this.items.forEach(element => {
        if (unique.includes(element.Medium.name) === false) {
          unique.push(element.Medium.name)
          items.push(element)
        }
      })
      const results = queryString ? items.filter(this.createFilter(queryString)) : []

      // call callback function to return suggestions
      cb(results.map(item => {
        item.value = item.Medium.name
        return item
      }))
    },
    createFilter (queryString) {
      return (item) => {
        return (item.Medium.name.toLowerCase().indexOf(queryString.toLowerCase()) > -1)
      }
    },
    handleSelect (item) {
      this.state = item.Medium.name
      this.$emit('input', item.Medium.name)
    }
  },
  async mounted () {
    const mediumId = document.getElementById('ext-config-medium-id').dataset.mediumid
    const path = 'medium/getPlaylistContentSimple'
    let playlistId = mediumId
    let playList
    await Vue.axios.post(path, { PlayList: playlistId })
      .then(response => {
        playList = response.data
      })
    // this.items = this.$store.state.Medium.media_list
    this.items = playList.PlayListItems
    this.state = this.$attrs.value
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ExtensionChoseMedium.vue